import { render, staticRenderFns } from "./CampoDeCnpjOuCpf.vue?vue&type=template&id=1178965a&"
import script from "./CampoDeCnpjOuCpf.vue?vue&type=script&lang=ts&"
export * from "./CampoDeCnpjOuCpf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
